import React, { useMemo, useState, useEffect } from 'react';
import { useMultipleSelection, useCombobox } from 'downshift';
import { useMergeRefs } from 'use-callback-ref';
import '../../../../assets/icons/custom/CheckIcon.es.js';
import '../../../../assets/icons/generated/filled/AndroidFilled.es.js';
import '../../../../assets/icons/generated/filled/AppleFilled.es.js';
import '../../../../assets/icons/generated/filled/ArrowForwardFilled.es.js';
import '../../../../assets/icons/generated/filled/CameraAddFilled.es.js';
import '../../../../assets/icons/generated/filled/CameraFilled.es.js';
import '../../../../assets/icons/generated/filled/CdPauseFilled.es.js';
import '../../../../assets/icons/generated/filled/CheckCircleFilled.es.js';
import '../../../../assets/icons/generated/filled/CommentsFilled.es.js';
import '../../../../assets/icons/generated/filled/CommentsTextFilled.es.js';
import '../../../../assets/icons/generated/filled/CreditCardFilled.es.js';
import '../../../../assets/icons/generated/filled/CrownFilled.es.js';
import '../../../../assets/icons/generated/filled/DownloadCircleFilled.es.js';
import '../../../../assets/icons/generated/filled/FacebookFilled.es.js';
import '../../../../assets/icons/generated/filled/FolderFilled.es.js';
import '../../../../assets/icons/generated/filled/HeartFilled.es.js';
import '../../../../assets/icons/generated/filled/HelpFilled.es.js';
import '../../../../assets/icons/generated/filled/InfoFilled.es.js';
import '../../../../assets/icons/generated/filled/InstagramFilled.es.js';
import '../../../../assets/icons/generated/filled/KebabFilled.es.js';
import '../../../../assets/icons/generated/filled/LightningFilled.es.js';
import '../../../../assets/icons/generated/filled/LinkFilled.es.js';
import '../../../../assets/icons/generated/filled/LinkedinFilled.es.js';
import '../../../../assets/icons/generated/filled/LockFilled.es.js';
import '../../../../assets/icons/generated/filled/MasterFilled.es.js';
import '../../../../assets/icons/generated/filled/MeatballsFilled.es.js';
import '../../../../assets/icons/generated/filled/PauseFilled.es.js';
import '../../../../assets/icons/generated/filled/PlayFilled.es.js';
import '../../../../assets/icons/generated/filled/RecordFilled.es.js';
import '../../../../assets/icons/generated/filled/RedditFilled.es.js';
import '../../../../assets/icons/generated/filled/ReleasesFilled.es.js';
import '../../../../assets/icons/generated/filled/RemoveFilled.es.js';
import '../../../../assets/icons/generated/filled/ReplyFilled.es.js';
import '../../../../assets/icons/generated/filled/SpotifyFilled.es.js';
import '../../../../assets/icons/generated/filled/StarFilled.es.js';
import '../../../../assets/icons/generated/filled/StarHalfFilled.es.js';
import '../../../../assets/icons/generated/filled/StopFilled.es.js';
import '../../../../assets/icons/generated/filled/TwitterFilled.es.js';
import '../../../../assets/icons/generated/filled/UsersFilled.es.js';
import '../../../../assets/icons/generated/filled/VolumeFilled.es.js';
import '../../../../assets/icons/generated/filled/VolumeMuteFilled.es.js';
import '../../../../assets/icons/generated/filled/WarningFilled.es.js';
import '../../../../assets/icons/generated/filled/WindowsFilled.es.js';
import '../../../../assets/icons/generated/filled/XFilled.es.js';
import '../../../../assets/icons/generated/filled/YoutubeFilled.es.js';
import '../../../../assets/icons/generated/outlined/CalendarOutlined.es.js';
import '../../../../assets/icons/generated/outlined/AddFileOutlined.es.js';
import '../../../../assets/icons/generated/outlined/AddOutlined.es.js';
import '../../../../assets/icons/generated/outlined/AddReleaseOutlined.es.js';
import '../../../../assets/icons/generated/outlined/AddToCollectionOutlined.es.js';
import '../../../../assets/icons/generated/outlined/AddSongOutlined.es.js';
import '../../../../assets/icons/generated/outlined/AlbumOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ArchiveOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ArrowBackOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ArrowForwardOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ArrowDownOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ArrowUpOutlined.es.js';
import '../../../../assets/icons/generated/outlined/AttachmentOutlined.es.js';
import '../../../../assets/icons/generated/outlined/BassOutlined.es.js';
import '../../../../assets/icons/generated/outlined/BellOutlinedOff.es.js';
import '../../../../assets/icons/generated/outlined/BellOutlined.es.js';
import '../../../../assets/icons/generated/outlined/BentoOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CameraOffOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CameraOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CancelOutlined.es.js';
import CaretDownOutlined from '../../../../assets/icons/generated/outlined/CaretDownOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CaretLeftOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CaretRightOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CaretUpOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CdArrowOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CdTimerOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CheckOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CheckCircleOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ClockHistoryOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ClockOutlined.es.js';
import CloseOutlined from '../../../../assets/icons/generated/outlined/CloseOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CloudUploadOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CogOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CommentMusicNoteOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ComputerDesktopOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CopyOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CouponOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CreditCardOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CrownOutlined.es.js';
import '../../../../assets/icons/generated/outlined/DeliveryOutlined.es.js';
import '../../../../assets/icons/generated/outlined/DiskOutlined.es.js';
import '../../../../assets/icons/generated/outlined/DownloadOutlined.es.js';
import '../../../../assets/icons/generated/outlined/DragOutlined.es.js';
import '../../../../assets/icons/generated/outlined/DrumsOutlined.es.js';
import '../../../../assets/icons/generated/outlined/EditOutlined.es.js';
import '../../../../assets/icons/generated/outlined/EmojiOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ExpandOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ExternalLinkOutlined.es.js';
import '../../../../assets/icons/generated/outlined/FileOutlined.es.js';
import '../../../../assets/icons/generated/outlined/FileTextOutlined.es.js';
import '../../../../assets/icons/generated/outlined/FilterOutlined.es.js';
import '../../../../assets/icons/generated/outlined/FiltersOutlined.es.js';
import '../../../../assets/icons/generated/outlined/FlagOutlined.es.js';
import '../../../../assets/icons/generated/outlined/FolderMusic.es.js';
import '../../../../assets/icons/generated/outlined/FolderOutlined.es.js';
import '../../../../assets/icons/generated/outlined/GiftOutlined.es.js';
import '../../../../assets/icons/generated/outlined/GlobeOutlined.es.js';
import '../../../../assets/icons/generated/outlined/GrandPianoOutlined.es.js';
import '../../../../assets/icons/generated/outlined/GridOutlined.es.js';
import '../../../../assets/icons/generated/outlined/GuitarOutlined.es.js';
import '../../../../assets/icons/generated/outlined/HandOutlined.es.js';
import '../../../../assets/icons/generated/outlined/HeadphonesAddOutlined.es.js';
import '../../../../assets/icons/generated/outlined/HeadphonesCheckedOutlined.es.js';
import '../../../../assets/icons/generated/outlined/HeadphonesOutlined.es.js';
import '../../../../assets/icons/generated/outlined/HeartOutlined.es.js';
import '../../../../assets/icons/generated/outlined/HelpOutlined.es.js';
import '../../../../assets/icons/generated/outlined/HideOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ImageOutlined.es.js';
import '../../../../assets/icons/generated/outlined/InfoOutlined.es.js';
import '../../../../assets/icons/generated/outlined/KeyOutlined.es.js';
import '../../../../assets/icons/generated/outlined/KeyboardOutlined.es.js';
import '../../../../assets/icons/generated/outlined/LeaveOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ListOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ListUnorderedOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ListMusicNoteOutlined.es.js';
import '../../../../assets/icons/generated/outlined/LockOutlined.es.js';
import '../../../../assets/icons/generated/outlined/LogoOutlined.es.js';
import '../../../../assets/icons/generated/outlined/LoopOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MagicWandOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MailOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MenuInvertedOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MenuOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MicrophoneOffOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MicrophoneOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MinimizeOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MinusOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MoneyOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MonitorOffOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MonitorOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MoveToFolderOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MusicNoteOff.es.js';
import '../../../../assets/icons/generated/outlined/MusicNote.es.js';
import '../../../../assets/icons/generated/outlined/NetworkOutlined.es.js';
import '../../../../assets/icons/generated/outlined/NoteOutlined.es.js';
import '../../../../assets/icons/generated/outlined/OrderOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PackOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PaperPlaneOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PencilOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PencilPaperOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PercentageOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PhoneOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PianoOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PlaylistOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PlusOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PreserverOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PriceTagOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ProductBlogOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ProductNetworkOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ProductPluginsOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ProductProjectsOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ProductReleasesOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ProductSamplesOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ProfileOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ProviderOutlined.es.js';
import '../../../../assets/icons/generated/outlined/QuoteOutlined.es.js';
import '../../../../assets/icons/generated/outlined/RemoveOutlined.es.js';
import '../../../../assets/icons/generated/outlined/RepeatOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ReplaceOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ReplyOutlined.es.js';
import '../../../../assets/icons/generated/outlined/SearchOutlined.es.js';
import '../../../../assets/icons/generated/outlined/SendFileToOutlined.es.js';
import '../../../../assets/icons/generated/outlined/SharingOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ShowOutlined.es.js';
import '../../../../assets/icons/generated/outlined/SidebarOutlined.es.js';
import '../../../../assets/icons/generated/outlined/SliderOutlined.es.js';
import '../../../../assets/icons/generated/outlined/SoundOutlined.es.js';
import '../../../../assets/icons/generated/outlined/StarOutlined.es.js';
import '../../../../assets/icons/generated/outlined/StoreOutlined.es.js';
import '../../../../assets/icons/generated/outlined/SuccessOutlined.es.js';
import '../../../../assets/icons/generated/outlined/SunOutlined.es.js';
import '../../../../assets/icons/generated/outlined/TiktokOutlined.es.js';
import '../../../../assets/icons/generated/outlined/TrashOutlined.es.js';
import '../../../../assets/icons/generated/outlined/TrendingUpOutlined.es.js';
import '../../../../assets/icons/generated/outlined/UpDownOutlined.es.js';
import '../../../../assets/icons/generated/outlined/UploadOutlined.es.js';
import '../../../../assets/icons/generated/outlined/UserMessageOutlined.es.js';
import '../../../../assets/icons/generated/outlined/UserOutlined.es.js';
import '../../../../assets/icons/generated/outlined/UserPlusOutlined.es.js';
import '../../../../assets/icons/generated/outlined/VideoChatOutlined.es.js';
import '../../../../assets/icons/generated/outlined/VideoOffOutlined.es.js';
import '../../../../assets/icons/generated/outlined/VideoOnOutlined.es.js';
import '../../../../assets/icons/generated/outlined/VideoOutlined.es.js';
import '../../../../assets/icons/generated/outlined/VideoRecordingOutlined.es.js';
import '../../../../assets/icons/generated/outlined/VideoSquareOutlined.es.js';
import '../../../../assets/icons/generated/outlined/WarningOutlined.es.js';
import '../../../../assets/icons/generated/products/Blog.es.js';
import '../../../../assets/icons/generated/products/ChromaticDark.es.js';
import '../../../../assets/icons/generated/products/Chromatic.es.js';
import '../../../../assets/icons/generated/products/CommunityChannels.es.js';
import '../../../../assets/icons/generated/products/Courses.es.js';
import '../../../../assets/icons/generated/products/Creator.es.js';
import '../../../../assets/icons/generated/products/Distribution.es.js';
import '../../../../assets/icons/generated/products/Insider.es.js';
import '../../../../assets/icons/generated/products/LandrFx.es.js';
import '../../../../assets/icons/generated/products/Mastering.es.js';
import '../../../../assets/icons/generated/products/NetworkPro.es.js';
import '../../../../assets/icons/generated/products/NetworkServices.es.js';
import '../../../../assets/icons/generated/products/Network.es.js';
import '../../../../assets/icons/generated/products/Plugins.es.js';
import '../../../../assets/icons/generated/products/ProjectsBlue.es.js';
import '../../../../assets/icons/generated/products/ProjectsRed.es.js';
import '../../../../assets/icons/generated/products/SamplesDark.es.js';
import '../../../../assets/icons/generated/products/Samples.es.js';
import '../../../../assets/icons/generated/products/SessionsDark.es.js';
import '../../../../assets/icons/generated/products/Sessions.es.js';
import '../../../../assets/icons/generated/products/Tutorials.es.js';
import '../../../../assets/icons/generated/products/Vocalign.es.js';
import { forwardRef } from '../../../../system/forwardRef.es.js';
import { Chip } from '../../../Chip/Chip.es.js';
import { Box } from '../../../../primitives/Box/Box.es.js';
import { IconButton } from '../../../IconButton/IconButton.es.js';
import { Input } from '../../../Input/Input.es.js';
import { AutocompleteDropdownProvider } from '../shared/AutocompleteContext.es.js';
import { Dropdown } from '../shared/Dropdown.es.js';
import { Item } from '../shared/Item.es.js';
import { Items } from '../shared/Items.es.js';
import { NoResults } from '../shared/NoResults.es.js';
import '../../../../utils/assertions.es.js';
import { runIfFn } from '../../../../utils/functions.es.js';
import '../../../../utils/responsive.es.js';
import '../../../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../../../utils/useEnhancedEffect.es.js';
import 'react-is';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultGetItemsLabel = (item) => item;
const defaultValueComponent = (_a) => {
  var _b = _a, { label, onRemove } = _b, rest = __objRest(_b, ["label", "onRemove"]);
  return /* @__PURE__ */ React.createElement(Box, {
    mx: "xxs",
    my: "6px"
  }, /* @__PURE__ */ React.createElement(Chip, __spreadValues({
    onDismiss: onRemove
  }, rest), label));
};
const MultiSelect = forwardRef((props, ref) => {
  const _a = props, {
    items = [],
    getItemsLabel = defaultGetItemsLabel,
    initialSelectedItems = [],
    shape,
    placeholder,
    onChange,
    onReset,
    itemComponent = Item,
    noResultsComponent: NoResultsComponent = NoResults,
    noResultsLabel = "No results match this query",
    bottomComponent,
    groupBy,
    getDisabledOption,
    maxValues = -1,
    valueComponent = defaultValueComponent,
    onOpen,
    onClose,
    isLoading,
    isDisabled,
    loadingComponent
  } = _a, rest = __objRest(_a, [
    "items",
    "getItemsLabel",
    "initialSelectedItems",
    "shape",
    "placeholder",
    "onChange",
    "onReset",
    "itemComponent",
    "noResultsComponent",
    "noResultsLabel",
    "bottomComponent",
    "groupBy",
    "getDisabledOption",
    "maxValues",
    "valueComponent",
    "onOpen",
    "onClose",
    "isLoading",
    "isDisabled",
    "loadingComponent"
  ]);
  const sortedOptions = useMemo(() => groupBy ? items.sort((a, b) => -groupBy(b).localeCompare(groupBy(a))) : items, [groupBy, items]);
  const [inputValue, setInputValue] = useState("");
  const [comboBoxRef, setComboBoxRef] = useState(null);
  const mergedRefs = useMergeRefs([ref, setComboBoxRef]);
  const { addSelectedItem, removeSelectedItem, selectedItems, getSelectedItemProps, getDropdownProps, reset } = useMultipleSelection({
    initialSelectedItems
  });
  const [hasReachedMaxValues, setHasReachedMaxValues] = useState(false);
  useEffect(() => {
    if (maxValues <= -1)
      return;
    setHasReachedMaxValues((selectedItems == null ? void 0 : selectedItems.length) >= maxValues);
  }, [maxValues, selectedItems]);
  const getFilteredItems = (items2) => items2.filter((item) => selectedItems.indexOf(item) < 0 && getItemsLabel(item).toLowerCase().startsWith(inputValue == null ? void 0 : inputValue.toLowerCase()));
  const handleIsOpenChange = ({ isOpen: isOpen2 }) => {
    switch (isOpen2) {
      case true:
        onOpen == null ? void 0 : onOpen();
        break;
      case false:
        onClose == null ? void 0 : onClose();
        break;
    }
  };
  const handleReset = () => {
    onReset == null ? void 0 : onReset();
    reset();
  };
  useEffect(() => {
    onChange == null ? void 0 : onChange(selectedItems);
  }, [onChange, selectedItems]);
  const {
    isOpen,
    getMenuProps,
    getInputProps,
    getToggleButtonProps,
    highlightedIndex,
    getItemProps,
    openMenu,
    toggleMenu
  } = useCombobox({
    selectedItem: null,
    items: getFilteredItems(sortedOptions),
    inputValue,
    itemToString: getItemsLabel,
    stateReducer: (_state, actionAndChanges) => {
      const { changes, type } = actionAndChanges;
      switch (type) {
        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.ItemClick:
          return __spreadProps(__spreadValues({}, changes), {
            isOpen: true
          });
      }
      return changes;
    },
    onStateChange: ({ selectedItem, type, inputValue: inputValue2 }) => {
      switch (type) {
        case useCombobox.stateChangeTypes.InputChange:
          setInputValue(inputValue2);
          break;
        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.ItemClick:
        case useCombobox.stateChangeTypes.InputBlur:
          if (selectedItem) {
            setInputValue("");
            addSelectedItem(selectedItem);
          }
          break;
      }
    },
    onIsOpenChange: handleIsOpenChange
  });
  const handleOpenMenu = () => {
    if (isDisabled) {
      return;
    } else {
      openMenu();
    }
  };
  return /* @__PURE__ */ React.createElement(AutocompleteDropdownProvider, {
    value: {
      isOpen,
      items: getFilteredItems(sortedOptions),
      inputValue,
      groupBy,
      hasReachedMaxValues,
      getDisabledOption
    }
  }, /* @__PURE__ */ React.createElement(Input, __spreadValues(__spreadValues({
    isMultiline: true,
    placeholder,
    shape,
    isDisabled,
    wrapperProps: { ref: mergedRefs, onClick: handleOpenMenu },
    addonLeft: selectedItems.map((selectedItem, index) => runIfFn(valueComponent, __spreadValues({
      item: selectedItem,
      label: getItemsLabel(selectedItem),
      onRemove: () => removeSelectedItem(selectedItem),
      key: `selected-item-${index}`
    }, getSelectedItemProps({ selectedItem, index })))),
    addonRight: [
      selectedItems.length > 0 && /* @__PURE__ */ React.createElement(IconButton, {
        key: "clear-button",
        size: "sm",
        variant: "subtle",
        isRounded: shape === "rounded",
        label: "",
        hideTooltip: true,
        icon: CloseOutlined,
        mr: "xxs",
        onClick: handleReset
      }),
      /* @__PURE__ */ React.createElement(IconButton, __spreadValues({
        isDisabled,
        key: "toggle-button",
        size: "sm",
        variant: "subtle",
        isRounded: shape === "rounded",
        label: "",
        hideTooltip: true,
        icon: CaretDownOutlined,
        mr: "xxs"
      }, getToggleButtonProps({ onClick: toggleMenu })))
    ]
  }, getInputProps({
    onFocus: () => {
      if (!isOpen) {
        handleOpenMenu();
      }
    }
  })), rest)), /* @__PURE__ */ React.createElement(Dropdown, __spreadValues({
    anchorRef: comboBoxRef
  }, getDropdownProps()), /* @__PURE__ */ React.createElement(Items, __spreadValues({
    itemComponent,
    itemProps: getItemProps,
    getItemsLabel,
    noResultsComponent: NoResultsComponent,
    noResultsLabel,
    highlightedIndex,
    isLoading,
    loadingComponent,
    bottomComponent
  }, getMenuProps()))));
});

export { MultiSelect };
//# sourceMappingURL=MultiSelect.es.js.map
